import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useLocalization } from '../../hooks/useLocalization';

import { FETCH_ACCOUNT_NAME } from './accountBreadcrumb.query';

export function AccountBreadcrumb() {
  const { translateBackendString } = useLocalization();
  const { t } = useTranslation();
  const { data } = useQuery(FETCH_ACCOUNT_NAME, {
    variables: { id: useParams().accountId },
  });

  return data
    ? translateBackendString(data.fetchAccount.account.translatedNickName) ||
        t(`accountTypes:${data.fetchAccount.account.type}`)
    : t('client:account');
}
